import { Combobox, Form } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import useBanqueSearch from '@/hooks/useBanqueSearch';

interface BanqueDropdownProps {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
  'data-testid'?: string;
  required?: boolean;
}

const BanqueDropdown = (props: BanqueDropdownProps) => {
  const { disabled, value, onChange, 'data-testid': dataTestId, required = false } = props;

  const { loading, options, onSearchChange } = useBanqueSearch();

  const allOptions = React.useMemo(() => {
    if (!_.isEmpty(value) && !_.some(options, { value })) {
      return [{ key: 'current', value, text: value }, ...options];
    }
    return options;
  }, [options, value]);

  const handleChange = React.useCallback(
    (e, { value: selected }) => {
      onChange(selected);
    },
    [onChange],
  );

  const handleAddition = React.useCallback(
    (e, { value: added }) => {
      onChange(added);
    },
    [onChange],
  );

  return (
    <Form.Field inline required={required}>
      <label>Banque</label>
      {/* @ts-expect-error */}
      <Combobox
        menuPortalTarget={document.body}
        data-testid={dataTestId}
        disabled={disabled}
        loading={loading}
        options={allOptions}
        search
        selection
        allowAdditions
        additionLabel=""
        noResultsMessage="Rechercher une banque..."
        placeholder="Crédit Mutuel"
        value={value}
        text={value || ''}
        onSearchChange={onSearchChange}
        onChange={handleChange}
        onAddItem={handleAddition}
        selectOnBlur
        style={{ width: 300 }}
      />
    </Form.Field>
  );
};

export default BanqueDropdown;
